import classname from 'classnames'

function ImgAd() {
  return (
    <div className={classname('w-full relative')}>
      <img
        src='//static.qiekj.com/static/web/image/9D6F72A5-D51C-41A8-8607-40FF85D471B8_1701424787093.png'
        alt=''
        className='absolute top-0'
      />
      <div className='relative rem:pt-[550px] flex justify-center z-10'>
        <div
          className='rem:w-[166px] rem:h-[52px] rem:mr-[15px]'
          onClick={() => {
            window.location.href =
              'https://szjy-edu.cn/education.html?utm_campaign=edu2&utm_source=yyl&utm_medium=01'
          }}
        ></div>
      </div>
    </div>
  )
}

export default ImgAd
